/*=========================================================================================
  File Name: moduleCompanyActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import * as constants from "@/constants";

export default {
	addItemCompany({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/company", item)
				.then((response) => {
					commit("ADD_COMPANY", Object.assign(item, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/company")
				.then((res) => {
					commit("SET_COMPANIES", res.data);
					resolve(res);
				})
				.catch((err) => {
					throw new Error(err);
				});
		});
	},
	updateItem({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/company/${item.id}`, item)
				.then((response) => {
					commit("UPDATE_COMPANY", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/company/${itemId}`)
				.then((response) => {
					commit("REMOVE_COMPANY", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	createServirouteCompany({commit}, data) {
		return new Promise((resolve, reject) => {
			Api.post("/serviroutes/company", data)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	checkAuthSessions({commit}) {
		const userInfo = JSON.parse(localStorage.userInfo);
		return new Promise((resolve, reject) => {
			Api.get(`/auth/sessions/${userInfo.access_token}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	serviroutesLogin({commit}) {
		const userInfo = JSON.parse(localStorage.userInfo);
		const data = {
			uid: userInfo.uid,
			email: userInfo.email,
			client_secret: process.env.VUE_APP_CLIENT_SECRET,
		};
		return new Promise((resolve, reject) => {
			fetch(constants.SERVIROUTES_API_BASE_URL + "/auth/login", {
				method: "POST",
				body: JSON.stringify(data), // data can be `string` or {object}!
				headers: {
					"Content-Type": "application/json",
				},
			})
				.then((response) => {
					return response.json();
				})
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getCompanyId({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/company/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
